// Z3950Document1 
import { Name10 } from '../../ui/ot';

const Z3950DocumentResponse1 = ({

}) => {
    return <>
        <Name10
            propsCategoryName="z3950設定"
            propsCategoryTitle="資料"

            mainApiRoute="/cataloging/backend/z3950/response"
            formColumnApi="/cataloging/backend/z3950/form"

            createApiRoute=''
            editPageFrontendRoute="/cataloging/z3950/_3"


            propsPrimaryColorName='blue'
            propsPrimaryColor="#1e40af"
            propsSecodaryColor="#2563eb"

            dbCoverIdName="z3950_document_id"
            tabDocumentResponseApiRoute='/cataloging/backend/z3950/response'
            tabDocumentApiRoute='/cataloging/backend/z3950_document/view'
        />



    </>
}
export default Z3950DocumentResponse1


